<template>
  <el-table
      :data="tableData"
      @selection-change="handleSelectionChange"
  >
    <el-table-column type="selection" width="50"></el-table-column>

    <el-table-column type="index" width="50"></el-table-column>

    <el-table-column prop="subBrandNumber" :label="$t('lang.子品牌编号')"></el-table-column>
    <el-table-column prop="subBrandName" :label="$t('lang.子品牌名称')"></el-table-column>
    <el-table-column prop="productSubModel" :label="$t('lang.适配型号')"></el-table-column>
    <el-table-column prop="createTimeStr" :label="$t('lang.创建时间')"></el-table-column>



    <el-table-column fixed="right" :label="$t('lang.操作')" width="260">
      <template slot-scope="scope">
        <el-button size="mini" @click='$router.push({path: "/apk-edit",query: {code: scope.row.code} });' plain  type="primary">
          {{ $t('lang.编辑资料') }}</el-button>
        <el-button size="mini" @click="handleSubmit(scope.row)" plain  type="primary">{{ $t('lang.提交审核') }}</el-button>
        <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "NotSubmitTable",
  props: {
    tableData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      api: {
        commitApproval: this.$api.subApk.commitApproval,
      }
    }
  },
  methods: {
    handleSelectionChange(selection) {
      this.$emit('selection-change', selection)
    },
    handleSubmit(row) {
      this.$emit('approval', row);
    },
    handleDelete(row) {
      this.$emit('delete', row);
    }
  },


}
</script>

<style scoped lang="scss">

</style>
